import { useTranslation } from 'react-i18next';
import { PageContent } from '@/components/layout/PageContent';
import { OrganizationSection } from '@/components/settings/OrganizationSection';
import { BrandingSection } from '@/components/settings/BrandingSection';
import { LanguageSection } from '@/components/settings/LanguageSection';
import { RegionalSection } from '@/components/settings/RegionalSection';
import { UsersSection } from '@/components/settings/UsersSection';
import { CostCentersSection } from '@/components/settings/CostCentersSection';
import { SecuritySection } from '@/components/settings/SecuritySection';
import { EInvoicingSection } from '@/components/settings/EInvoicingSection';
import { ReportScheduleSection } from '@/components/settings/ReportScheduleSection';
import { BudgetSection } from '@/components/settings/BudgetSection';
import { TaxGlSection } from '@/components/settings/TaxGlSection';
import { FiscalPeriodSection } from '@/components/settings/FiscalPeriodSection';
import { AuditLogSection } from '@/components/settings/AuditLogSection';
import { SettingsNav } from '@/components/settings/SettingsNav';
import { SettingsSectionGuard } from '@/components/settings/SettingsSectionGuard';

export function SettingsPage() {
  const { t } = useTranslation();

  return (
    <PageContent>
      <h1 className="text-2xl font-bold">{t('settings.title')}</h1>
      <SettingsNav />

      <SettingsSectionGuard sectionId="organization">
        <OrganizationSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="branding">
        <BrandingSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="language">
        <LanguageSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="regional">
        <RegionalSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="users">
        <UsersSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="costCenters">
        <CostCentersSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="security">
        <SecuritySection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="eInvoicing">
        <EInvoicingSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="reportSchedule">
        <ReportScheduleSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="budget">
        <BudgetSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="taxGl">
        <TaxGlSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="fiscalPeriod">
        <FiscalPeriodSection />
      </SettingsSectionGuard>
      <SettingsSectionGuard sectionId="auditLog">
        <AuditLogSection />
      </SettingsSectionGuard>
    </PageContent>
  );
}
